<template>
    <transition name="fade-in-left">
        <div>
            <div v-for="(message, index) in messages">
                <div class="form-group">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="text-left">
                            <label>
                                How many days should we wait to send the follow-up?
                            </label>
                        </div>
                        <div class="text-right mb-2">
                            Follow-up message #{{messages.indexOf(message) + 1}}
                            <button class="swell-btn btn btn-primary btn-sm px-3"
                                @click="deleteFollow(index, text)"
                                v-if="messages.length > 1">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>
                    <input type="number" min="0" class="form-control" v-model="message.delay_days" />
                    <p class="invalid-feedback"
                       v-if="errors.has('messages' + '.' + [index] + '.' + 'delay_days')">
                        {{ errors.get('messages' + '.' + [index] + '.' + 'delay_days') }}
                    </p>
                </div>
                <div class="form-group">
                    <div class="text-left">
                        <label>For which invite statuses should we send the follow-up?</label>
                    </div>
                    <multiselect
                            :options="statuses"
                            :multiple="true"
                            track-by="name"
                            label="name"
                            :hide-selected="true"
                            :close-on-select="false"
                            placeholder="Statuses"
                            v-model="message.statuses"
                            @input="checkIfIsSelectAll">
                    </multiselect>
                    <p class="invalid-feedback"
                       v-if="errors.has('messages' + '.' + [index] + '.' + 'statuses')">
                        {{ errors.get('messages' + '.' + [index] + '.' + 'statuses') }}
                    </p>
                </div>
                <div class="form-group">
                    <label>Custom Subject</label>
                    <input type="text" class="form-control" v-model="message.subject" placeholder="Default is the subject used in the primary invite"/>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-6">
                      <label>Custom Message</label>
                    </div>
                    <div class="col-6">
                      <message-template-selector
                        :message="message.content"
                        @messageUpdated="message.content = $event"/>
                    </div>
                  </div>
                    <textarea class="form-control" v-model="message.content"></textarea>
                    <p class="invalid-feedback"
                       v-if="errors.has('messages' + '.' + [index] + '.' + 'content')">
                        {{ errors.get('messages' + '.' + [index] + '.' + 'content') }}
                    </p>
                </div>
            </div>
            <button class="swell-btn btn btn-primary btn-sm px-3" @click="newFollow()">
                <i class="fa fa-plus"></i>
            </button>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'follow-up',

        props: {
            statuses: {
                type: Array,
                required: true
            },
            messages: {
                type: Array,
                required: true
            },
            errors: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
              variable: ''
            }
        },

        methods: {
            checkIfIsSelectAll(options) {
                if( options.filter(f => f.id === 0).length > 0 ) {
                    this.selectedLocations = this.locations.filter(f => f.id !== 0);
                }
            },

            newFollow () {
                this.$emit('newMessage');
            },

            deleteFollow(index) {
                this.$emit('deleteMessage', index);
            }
        }
    }
</script>
